import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { EmployeedeleteRoutingModule } from './employeedelete-routing.module';
import { EmployeeLoginComponent } from './employee-login/employee-login.component';
import { EmpdeleteDialogComponent } from './empdelete-dialog/empdelete-dialog.component';
import { NgxSpinnerModule } from 'ngx-spinner';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';





@NgModule({
  declarations: [
    EmployeeLoginComponent,
    EmpdeleteDialogComponent,
  ],
  imports: [
    CommonModule,
    EmployeedeleteRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    NgxSpinnerModule.forRoot({ type: 'ball-scale-multiple' }),
  ]
})
export class EmployeedeleteModule { }
